<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/bank/bankAffiliate")
          i.fas.fa-landmark
          span.ml-1 {{ $t("ui.bank_affiliate") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getBankAffList()"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="11%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="11%" @click="sortOrder('bank_id')")
                        span(:title="$t('ui.bank_id')") {{ $t("ui.bank_id") }}
                        i(:class="changeSortKey('bank_id')")
                      th.sticky-position.sortable(width="22%" @click="sortOrder('bank_name')")
                        span(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
                        i(:class="changeSortKey('bank_name')")
                      th.sticky-position.sortable(width="15%")
                        span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      th.sticky-position.sortable(width="22%" @click="sortOrder('bank_acc_holder')")
                        span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                        i(:class="changeSortKey('bank_acc_holder')")
                      th.text-center.sticky-position(width="7%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                      th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_by')")
                        span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                        i(:class="changeSortKey('created_by')")
                      th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_date')")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date')")
                  tbody.clusterize-content
                    tr(v-if="bankAffList.length == 0")
                      td(colspan="9").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in bankAffList")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id") {{ item.account_id }}
                      td
                        span(:title="item.bank_id") {{ item.bank_id }}
                      td
                        span(:title="item.bank_name") {{ item.bank_name }}
                      td
                        span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                      td
                        span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
                      td.actions
                        span
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                      td.text-right
                        span(:title="item.created_by") {{ item.created_by }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    editbankaffiliate(ref="editbankaffiliate" :item="editSelectedBankAffiliate" @clicked="afterEditBankAffiliate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editbankaffiliate from "@/components/affiliate/editBankAffiliate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editbankaffiliate
  },
  data: () => ({
    loading: false,
    bankAffList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBankAffiliate: null,
    sortKey: "account_id",
    sortType: "asc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  mounted: function() {
    this.getBankAffList(true);
  },
  methods: {
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getBankAffList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onEdit(e) {
      this.editSelectedBankAffiliate = e;
      this.$refs.editbankaffiliate.$refs.editBankAffiliate.show();
    },
    afterEditBankAffiliate: function(item) {
      this.getBankAffList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_bank_affiliate"), this.$t("message.success"), "success");
    },
    getBankAffList: function(isSearch) {
      let url = config.bankAccountListAffiliateUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };

      if (this.search.trim() != '')
        json.search_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bankAffList = response.data.dt;
                this.totalRow = this.bankAffList.length > 0 ? this.bankAffList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getBankAffList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBankAffList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>